export const dataURItoBlob = (dataURI: string) => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  let ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
};

export const getBase64ImageFileSize = (base64String: string) => {
  let stringLength = base64String.length - 'data:image/png;base64,'.length;

  let sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
  let sizeInKb = sizeInBytes / 1000;

  return sizeInKb;
};
